export default "__VITE_ASSET__D8DvHIf8__"